import TagManager from "react-gtm-module";

function DeleteSchoolStartCP({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "delete_school_start",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default DeleteSchoolStartCP;
